import { render, staticRenderFns } from "./Средний чек.vue?vue&type=template&id=09ef6af2&scoped=true"
import script from "./Средний чек.vue?vue&type=script&lang=js"
export * from "./Средний чек.vue?vue&type=script&lang=js"
import style0 from "./Средний чек.vue?vue&type=style&index=0&id=09ef6af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef6af2",
  null
  
)

export default component.exports